import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import UserModalForm from 'components/Users/UsersModalForm';

import { createStaff, editStaff } from 'redux/modules/staff/effects';
import { withRouter } from 'react-router-dom';
import config from 'config';

class OnTruckUserEdit extends Component {
  formatVal = (val) => {
    const { isCustomerService, isDispatcher, group, ...rest } = val;
    const groups = [
      group,
      ...(isDispatcher ? ['Dispatcher'] : []),
      ...(isCustomerService ? ['CustomerService'] : []),
    ];

    return {
      ...rest,
      groups,
    };
  };

  closeModal = () => {
    const { history } = this.props;
    history.push({ pathname: `${config.BASE_ROUTE}user` });
  };

  editUser = (val) => {
    this.closeModal();
    this.props.editStaff(this.formatVal(val));
  };

  createUser = (val) => {
    this.closeModal();
    this.props.createStaff(this.formatVal(val));
  };

  render() {
    const { userId, loading } = this.props;

    return (
      !loading && (
        <UserModalForm
          show={true}
          close={this.closeModal}
          onSend={userId ? this.editUser : this.createUser}
          id={userId}
        />
      )
    );
  }
}

OnTruckUserEdit.propTypes = {
  loading: PropTypes.bool,
  createStaff: PropTypes.func.isRequired,
  editStaff: PropTypes.func.isRequired,
  userId: PropTypes.string,
};

const mapStateToProps = (state, { match }) => ({
  userId: match.params.id,
  loading: state.staff.fetching,
});

const mapDispatchToProps = {
  createStaff,
  editStaff,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OnTruckUserEdit));
